import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { FLOWS_PROJECTS_COLUMN_ID } from "../constants";
import { FlowsProjectRow } from "../types";
import FlowsProjectsListAssignedRolesCell from "./AssignedRolesCell";
import FlowsProjectsListNameCell from "./NameCell";

const FLOWS_PROJECTS_CELLS: TableCellPerColumn<FlowsProjectRow> = {
  [FLOWS_PROJECTS_COLUMN_ID.NAME]: FlowsProjectsListNameCell,
  [FLOWS_PROJECTS_COLUMN_ID.ASSIGNED_ROLES]: FlowsProjectsListAssignedRolesCell,
};

export default FLOWS_PROJECTS_CELLS;
